import { render, staticRenderFns } from "./AggregateSoul.vue?vue&type=template&id=35960926&scoped=true&"
import script from "./AggregateSoul.vue?vue&type=script&lang=js&"
export * from "./AggregateSoul.vue?vue&type=script&lang=js&"
import style0 from "./AggregateSoul.vue?vue&type=style&index=0&id=35960926&prod&scoped=true&lang=css&"
import style1 from "./AggregateSoul.vue?vue&type=style&index=1&id=35960926&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35960926",
  null
  
)

export default component.exports